import { render, staticRenderFns } from "./IxTree.vue?vue&type=template&id=18aa9932&scoped=true&"
import script from "./IxTree.vue?vue&type=script&lang=js&"
export * from "./IxTree.vue?vue&type=script&lang=js&"
import style0 from "./IxTree.vue?vue&type=style&index=0&id=18aa9932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa9932",
  null
  
)

export default component.exports